interface Dict {
  <K extends string | number | symbol, T>(): Record<K, T | undefined>
  <K extends string | number | symbol, T>(defaultValue: T): Record<K, T>
}

/**
 * An {@link Object} that prefills default value for non-existing entries when
 * getting.
 */
const dict: Dict = (...args: [] | [unknown]) => {
  return new Proxy(
    {},
    {
      get(target, p, receiver) {
        if (!Reflect.has(target, p) && args.length) {
          Reflect.set(target, p, args[0], receiver)
        }
        return Reflect.get(target, p, receiver)
      },
    },
  )
}

export default dict
